import { IAsyncBuilder } from "../../../../Global/Base/Builders/IBuilder";

export interface IContentBuilder extends IAsyncBuilder<HTMLElement> {
    build(): Promise<HTMLElement>;
}
